import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wechat-callback-container" }
const _hoisted_2 = { class: "loading-wrapper" }
const _hoisted_3 = { class: "loading-text" }

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { get } from '@/api/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'WechatCallback',
  setup(__props) {

const router = useRouter();
const loadingText = ref('正在处理微信支付回调...');

// 返回上一个页面的函数
const goBack = () => {
  try {
    // 方案1: 如果有历史记录，返回上一个页面
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    
    // 方案2: 如果是新开窗口且有父窗口，尝试关闭当前窗口
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }
    
    // 方案3: 如果以上都不行，跳转到首页
    router.push('/');
  } catch (error) {
    console.error('返回上一个页面失败:', error);
    // 最后的备选方案：跳转到首页
    router.push('/');
  }
};

onMounted(() => {
  handleWechatCallback();
});

// 调用微信支付接口
const callWxPayAPI = async (orderNumber: string, code: string) => {
  try {
    loadingText.value = '正在请求微信支付接口...';
    
    const response = await get('/wxPayMobile/wxPay', {
      orderNumber,
      code
    });
    
    console.log('微信支付接口返回结果:', response.data);
    loadingText.value = '微信支付接口请求成功！';
    
    // 将返回结果存储到sessionStorage中
    sessionStorage.setItem('wxPayResult', JSON.stringify(response.data));
    
    // 根据返回结果进行后续处理
    handlePaymentResult(response.data);
    
  } catch (error) {
    console.error('调用微信支付接口失败:', error);
    loadingText.value = '微信支付接口请求失败，请重试';
    
    setTimeout(() => {
      goBack();
    }, 3000);
  }
};

// 处理支付结果
const handlePaymentResult = (result: any) => {
  try {
    // 检查返回结果格式
    if (!result || result.code !== 0 || !result.data) {
      throw new Error('接口返回数据格式错误或请求失败');
    }
    
    // 从返回结果的data字段中提取支付参数
    const payMap = result.data;
    
    const appId = payMap.appId;
    const timeStamp = payMap.timeStamp;
    const nonceStr = payMap.nonceStr;
    const pg = payMap.pg;
    const signType = payMap.signType;
    const paySign = payMap.paySign;
    
    // 验证必需的支付参数
    if (!appId || !timeStamp || !nonceStr || !pg || !signType || !paySign) {
      throw new Error('支付参数不完整');
    }
    
    loadingText.value = '正在调起微信支付...';
    
    // 调用微信支付
    callWeixinPay(appId, timeStamp, nonceStr, pg, signType, paySign);
    
  } catch (error) {
    console.error('处理支付参数失败:', error);
    loadingText.value = '支付参数错误，请重试';
    setTimeout(() => {
      goBack();
    }, 3000);
  }
};

// 微信支付函数
const callWeixinPay = (appId: string, timeStamp: string, nonceStr: string, pg: string, signType: string, paySign: string) => {
  const onBridgeReady = () => {
    // 声明 WeixinJSBridge 类型
    const WeixinJSBridge = (window as any).WeixinJSBridge;
    
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        "appId": appId,
        "timeStamp": timeStamp,
        "nonceStr": nonceStr,
        "package": "prepay_id=" + pg,
        "signType": signType,
        "paySign": paySign
      },
      function(res: any) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 支付成功
          loadingText.value = '支付成功！';
          setTimeout(() => {
            // 返回上一个页面
            goBack();
          }, 3000);
        } else {
          // 支付失败或取消
          console.log('微信支付结果:', res);
          loadingText.value = '支付失败或已取消';
          setTimeout(() => {
            goBack();
          }, 3000);
        }
      }
    );
  };

  const initWeixinPay = () => {
    const WeixinJSBridge = (window as any).WeixinJSBridge;
    
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
      } else if ((document as any).attachEvent) {
        (document as any).attachEvent('WeixinJSBridgeReady', onBridgeReady);
        (document as any).attachEvent('onWeixinJSBridgeReady', onBridgeReady);
      }
    } else {
      onBridgeReady();
    }
  };

  // 开始支付
  initWeixinPay();
};

const handleWechatCallback = () => {
  try {
    // 获取URL参数
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const orderNumber = urlParams.get('orderNumber');
    
    console.log('微信回调参数:', { code, orderNumber });
    
    if (!code) {
      loadingText.value = '未获取到微信授权码，请重新支付';
      setTimeout(() => {
        // 3秒后返回上一个页面
        goBack();
      }, 3000);
      return;
    }
    
    if (!orderNumber) {
      loadingText.value = '未获取到订单号，请重新支付';
      setTimeout(() => {
        // 3秒后返回上一个页面
        goBack();
      }, 3000);
      return;
    }
    
    // 将code和orderNumber存储到sessionStorage中，供后续处理
    sessionStorage.setItem('wechatPayCode', code);
    sessionStorage.setItem('wechatPayOrderNumber', orderNumber);
    
    loadingText.value = '获取微信授权成功，准备处理支付...';
    
    // 调用微信支付接口
    callWxPayAPI(orderNumber, code);
    
  } catch (error) {
    console.error('处理微信回调失败:', error);
    loadingText.value = '处理微信回调失败，请重新支付';
    setTimeout(() => {
      goBack();
    }, 3000);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(loadingText.value), 1)
    ])
  ]))
}
}

})